// Plugins
//window.swal = require('sweetalert2');
//window.perfect = require('perfect-scrollbar');
import 'select2';
$('.select2x').select2();


// Validate email
window.ValidEmail = function (mail) {
  var pattern = /^[a-zA-Z0-9]+[a-zA-Z0-9._-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return pattern.test(mail);
}

/*
// Back to top
var $gotop = $('#gotop');
if ($(window).width() < 768) $gotop.hide();
else {
  $gotop.find('a').click(function () {
    $('html, body').animate({ scrollTop: 0 }, 600);
    return false;
  });

  $(window).scroll(function () {
    if ($(this).scrollTop() >= 200) $gotop.fadeIn(200);
    else $gotop.fadeOut(200);
  });
}
*/

// Slick gallery
import 'slick-carousel';

// Slick center slider
$(".discover .slider").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 3,
  centerPadding: '145px',
  responsive: [
    {
      breakpoint: 1380,
      settings: {
        centerPadding: '170px',        
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerPadding: '50px',
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '0px',
        slidesToScroll: 3
      }
    }
  ]
});

$(".discover .sliders").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerPadding: '0',
  // prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  // nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
      breakpoint: 1380,
      settings: {
        centerPadding: '0px',        
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerPadding: '0',
        slidesToScroll: 1,
        arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '0',
        slidesToScroll: 1,
        arrows: false,
      }
    }
  ]
});

$(".discover .slider-s").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerPadding: '0',
  // prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  // nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
      breakpoint: 1380,
      settings: {
        centerPadding: '0',        
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerPadding: '0px',
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        centerMode: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '0',
        slidesToShow: 1.4,
        slidesToScroll: 2,
        infinite: false,
        dots: false,
        centerMode: false,
        speed:300,
      }
    }
  ]
});

$(".discover .slider-ss").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 5,
  slidesToScroll: 1,
  centerPadding: '0',
  // prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  // nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
      breakpoint: 1380,
      settings: {
        centerPadding: '0',        
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerPadding: '0px',
        slidesToShow: 2,
        slidesToScroll: 1,
        arrows: true,
        infinite: true,
        centerMode: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '0px',
        slidesToShow: 2.4,
        slidesToScroll: 2,
        infinite: false,
        dots: false,
        centerMode: false,
        speed:300,
      }
    }
  ]
});

$(".discover .sliderns").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  centerPadding: '0',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [    
    {
      breakpoint: 768,
      settings: {
        centerPadding: '5px',
        slidesToScroll: 1,
       // arrows: false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '5px',
        slidesToScroll: 1,
       // arrows: false,
      }
    }
  ]
});

$(".discover .slider-gallery").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 6,
  slidesToScroll: 1,
  centerPadding: '20px',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [    
    {
      breakpoint: 1380,
      settings: {
        centerPadding: '0px', 
        slidesToShow: 5,       
      }
    },
    {
      breakpoint: 768,
      settings: {
        centerPadding: '0px',
        slidesToScroll: 1,
        slidesToShow: 3,
       arrows: true,
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '0px',
        slidesToScroll: 1,
        slidesToShow: 3,
       arrows: true,
      }
    }
  ]
});

$(".discover .slidernew").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerPadding: '0',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerPadding: '5px',
        slidesToScroll: 1,
        slidesToShow: 2,        
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '5px',
        slidesToScroll: 1,
        slidesToShow: 2,        
      }
    }
  ]
});

$(".discover .slidernews").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  centerPadding: '0',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        centerPadding: '5px',
        slidesToScroll: 1,
        slidesToShow: 1,
        
      }
    },
    {
      breakpoint: 480,
      settings: {
        centerPadding: '5px',
        slidesToScroll: 1,
        slidesToShow: 1,        
      }
    }
  ]
});


$(".discover-home .sliderss").slick({
  arrows: true,
  infinite: true,
  centerMode: true,
  slidesToShow: 4,
  slidesToScroll: 3,
  centerPadding: '5px',
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [{
    breakpoint: 1000,
    settings: {
      slidesToShow: 3,
      centerPadding: '5px',
      slidesToScroll: 2
    }
  }, {
    breakpoint: 768,
    settings: {
      slidesToShow: 2,
      centerPadding: '5px',
      slidesToScroll: 2
    }
  }, {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      slidesToScroll: 1,
      centerPadding: '5px'
    }
  }]
});



// Slick center slider
$(".banner-sales-home .slider").slick({
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  centerMode: false,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  prevArrow: '<div class="slick-prev"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_left</i></div>',
  nextArrow: '<div class="slick-next"><i style="color:#3F3A36;font-size:40px" class="material-icons">keyboard_arrow_right</i></div>',
  responsive: [
    {
      breakpoint: 768,
      settings: {
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToScroll: 1
      }
    }
  ]
});




// $(document).bind("contextmenu", function (e) {
//   e.preventDefault();
// });

// We also check for a text selection if ctrl/command are pressed along w/certain keys
$(document).keydown(function (ev) {
  // capture the event for a variety of browsers
  ev = ev || window.event;
  // check to see that either ctrl or command are being pressed along w/any other keys

});


// Menu promotion flicker
$('header a[href="/khuyen-mai"]').addClass('flicker');


// WEBPACK FOOTER //
// ./src/general.js